import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=55cae248&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=55cae248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cae248",
  null
  
)

export default component.exports